import React, { Component } from 'react';
import { MyInput } from '../elements/MyInput';
import { Table } from 'reactstrap';
import { WinnerBox } from '../elements/WinnerBox'
import { WinnerTable } from '../tables/winner/WinnerTable';

import backpic from '../images/41.jpg';
export class GhoreFirstPage extends Component {
    static displayName = GhoreFirstPage.name;


    constructor(props) {
        super(props);
        this.state = {};
        this.state.data = {};



        this.startClick = this.startClick.bind(this);

    }

    startClick() {
        if (typeof this.props.onStartClick === "function") {
            this.props.onStartClick();
        }
    }

    componentDidMount() {

    }








    render() {

        var address = "/Images/" + this.props.prize.prizeImageUrl;
        console.log(address);
        return (

            <div style={{width:"100%"}}>
                <div style={{ height: "100%",opacity:0.05, zIndex: -1, top: 0, left: 0, bottom: 0, right: 0, position: "absolute",backgroundSize: "2000px 100%", backgroundImage: `url(${backpic}) ` }}>

                </div>

                <div style={{ height: "100%", width: "100%"}}>


                    <div className="row">

                        <div className="col-md-12">
                            <br />
                            <br />
                            <br />
                        </div>

                        <div className="col-md-4">
                        </div>

                        <div className="col-md-4" style={{ background: "#f0f0f0" }}>
                            <Table>
                                <tbody>
                                    <tr>
                                        <td>نام جایزه</td>
                                        <td>{traverse(this.props.prize.prizeRealName)}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="2">
                                            <img src={address} style={{ width: "100%" }} />
                                        </td>

                                    </tr>

                                    <tr>
                                        <td>تعداد شرکت کنندگان</td>
                                        <td>{traverse(this.props.max)}</td>
                                    </tr>
                                    <tr>
                                        <td>تعداد کل</td>
                                        <td>{traverse(this.props.prize.cap)}</td>
                                    </tr>
                                    <tr>
                                        <td>تعداد مانده</td>
                                        <td>{traverse(this.props.prize.remain)}</td>
                                    </tr>

                                </tbody>
                            </Table>
                            <input type="button" className="btn btn-primary" style={{ width: "100%", padding: "20px" }} value="شروع" onClick={this.startClick} />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const persian = { 0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹' };
function traverse(el) {
    el=el.toString();
    var list = el.match(/[0-9]/g);
    if (list != null && list.length != 0) {
        for (var i = 0; i < list.length; i++)
            el = el.replace(list[i], persian[list[i]]);
    }
    return el;


}


// WEBPACK FOOTER //
// ./src/components/GhoreFirstPage.js